/**
 * Константы времени для удобства использования в триггерах
 */
export const TIME = {
  SECOND: 1,
  MINUTE: 60,
  HOUR: 3600,
  DAY: 86400,
  WEEK: 604800
} as const
